import { CurrencyService } from 'src/app/services/currency.service';
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import DateUtils from 'src/app/utils/date';
import { DealModel } from 'src/app/models/deal.model';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportCurrencyFormatter } from 'src/app/models/reportCurrencyFormatter';

@Component({
  selector: 'app-deal-forecast-won-report',
  templateUrl: './deal-forecast-won-report.component.html',
  styleUrls: ['./deal-forecast-won-report.component.css']
})
export class DealForecastWonReportComponent implements OnInit {
  baseCurrency;
  dateUtil = new DateUtils;
  selectedYr = new Date().getFullYear();
  selectedIds = null;
  selectedType = null;
  selectedNames = null;
  selectedPeriod = 'monthly';
  defMonthData = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
  monthsList;
  dealsData;
  showResult = false;
  salespersonbyMonth = [
    { name: 'Sodiq Alabi', forecastAmount: { ...this.defMonthData }, dealAmount: { ...this.defMonthData } },
    { name: 'Omah Lay', forecastAmount: { ...this.defMonthData }, dealAmount: { ...this.defMonthData } },
    { name: 'Tems Baby', forecastAmount: { ...this.defMonthData }, dealAmount: { ...this.defMonthData } },
  ]
  mutipleSalespTeams;
  mutipleSalespTeamsTableData;
  years;
  months = {
    baseAmount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    forecastAmount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
  };
  showGraph = false
  public chartOptions = {
    series: [
      {
        name: "forecast amount",
        data: [0, 1, 2, 4, 3, 2, 1, 3, 2, 1, 6]
      },
      {
        name: "deal won amount",
        data: [2, 1, 4, 3, 2, 1, 1, 2, 1, 1, 3]
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        // distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    colors: ["#0866C6", "#00c851"],
    xaxis: {
      title: {
        text: 'Months',
      },
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
      title: {
        text: 'Amount',
      },
      labels: {
        formatter: function (value) {
          const currencyF = new ReportCurrencyFormatter();
          return currencyF.handleFormatter(value)
        }
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return this.baseCurrency + val;
        }
      }
    },

  };
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    private currencySrv: CurrencyService) {
    this.years = this.dateUtil.getYears();
    this.currencySrv.org_currencies.subscribe((org_currencies) => {
      this.baseCurrency = org_currencies && org_currencies.base_currency ? org_currencies.base_currency : "";
    });
  }
  ngOnInit() {
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type, names } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.selectedNames = names;
        this.getData()
      } else {
        this.getData()
      }
    })
  }

  getSumUp = (data: any[]): number => data.reduce((prev, cur) => prev + cur);
  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.getData();
  }

  getData() {
    this.resetGraph();
    const dateFilter = this.dateUtil.getYearToDateRange(this.selectedYr);
    let filter: any = { dateFilter }
    if (this.selectedType === 'salesperson') {
      filter = { ...filter, salesPerson: { ids: this.selectedIds } }
    }

    const query = `itemType=Deals&range={"createdOn":{"from":${dateFilter.startDate},"to":${dateFilter.endDate}}}`;
    const getDeals = this.dealSrv.fetchDeals(this.selectedIds, filter)
    const getCurEqui = this.currencySrv.filter_organisation_currencies(query)
    forkJoin([getDeals, getCurEqui]).subscribe(([dealsRes, curEquiRes]) => {
      const deals = dealsRes;
      this.dealsData = dealsRes;
      const dealEquivelents = this.convertCurEqiToObj(curEquiRes.payload);
      deals.forEach(deal => {
        if (!deal.forecastAmount || deal.forecastAmount === '0') {
          deal.forecastAmount = 0;
        } else {
          const parseAmount = Number(Number(deal.forecastAmount).toFixed(2))
          const forecastAmount = this.currencySrv.convert_to_base_currency(parseAmount, deal.currency)
          deal.forecastAmount = forecastAmount
        }
        if (dealEquivelents[deal.code]) {
          deal.baseAmount = dealEquivelents[deal.code].equivalents[this.baseCurrency];
        }
      })
      this.graphManipulation(deals);
    })
  }


  convertCurEqiToObj(datas: any[]) {
    const obj = {};
    datas.forEach(dat => obj[dat.itemId] = dat)
    return obj
  }
  mutipleSelectedIds() {
    const result = {};
    const quaters = ['Q1', 'Q2', 'Q3', 'Q4']
    this.monthsList = this.selectedPeriod === 'quaterly' ? quaters : this.dateUtil.monthList;
    this.selectedIds.forEach(id => {
      result[id] = { forecastAmount: { ...this.defMonthData }, baseAmount: { ...this.defMonthData } }
    })
    this.mutipleSalespTeams = result;
  }
  getMnt = (d) => new Date(d).getMonth()

  graphManipulation(deals: DealModel[]) {
    const sKey = this.selectedType === 'salesperson' ? 'creatorID' : 'teamID';
    if (this.selectedIds && this.selectedIds.length) {
      this.mutipleSelectedIds();
    }
    deals.forEach(deal => {
      const month = new Date(deal.createdDate).getMonth();
      if (deal.forecastDate) {
        this.updateSalespOrTeam(deal[sKey], 'forecastAmount', deal.forecastAmount, this.getMnt(deal.forecastDate));
        this.updateMonth('forecastAmount', deal.forecastAmount, this.getMnt(deal.forecastDate));
      }
      if (deal.actualClosedDate) {
        if (deal.forecastAmount && deal.status === 2) {
          this.updateMonth('baseAmount', deal.baseAmount, this.getMnt(deal.actualClosedDate));
          this.updateSalespOrTeam(deal[sKey], 'baseAmount', deal.baseAmount, this.getMnt(deal.actualClosedDate));
        }
      }
    })
    const multiSalesPTeams = [];
    if (this.selectedIds && this.selectedIds.length && this.selectedNames) {
      Object.keys(this.mutipleSalespTeams).forEach(id => {
        const data = this.mutipleSalespTeams[id];
        multiSalesPTeams.push({ name: `${this.selectedNames[id].name}`, ...data })
      });
    }

    if (this.selectedPeriod === 'quaterly') {
      const { quatersLabel, quarters: faQuarter } = this.dateUtil.getQuarterlyData(this.months.forecastAmount);
      const { quarters: baseQuarter } = this.dateUtil.getQuarterlyData(this.months.baseAmount);
      this.chartOptions.xaxis.categories = quatersLabel;
      this.chartOptions.series[0].data = faQuarter;
      this.chartOptions.series[1].data = baseQuarter;
      const quaterMmultiSalesPTeams = []
      if (this.selectedNames) {
        multiSalesPTeams.forEach(salepData => {
          const forecastAmount = this.dateUtil.getQuarterlyData(salepData.forecastAmount).quartersObj;
          const baseAmount = this.dateUtil.getQuarterlyData(salepData.baseAmount).quartersObj;
          quaterMmultiSalesPTeams.push({ name: salepData.name, forecastAmount, baseAmount })
        });
        this.mutipleSalespTeamsTableData = quaterMmultiSalesPTeams
      }
    } else {
      const baseAmountResult = [];
      const forecastAmountResult = [];
      Object.values(this.months.forecastAmount).forEach(v => forecastAmountResult.push(v));
      Object.values(this.months.baseAmount).forEach(v => baseAmountResult.push(v));
      this.chartOptions.series[0].data = forecastAmountResult;
      this.chartOptions.series[1].data = baseAmountResult;
      this.chartOptions.xaxis.categories = this.dateUtil.monthList;
      this.mutipleSalespTeamsTableData = multiSalesPTeams;
      this.showResult = this.getSumUp(baseAmountResult) || this.getSumUp(forecastAmountResult) ? true : false;
    }
    this.showGraph = true;
  }
  updateMonth(type: string, amount: number, month: number) {
    let count = this.months[type][month];
    if (count || count === 0) {
      count = count + Number(amount)
    }
    this.months[type][month] = count;
  }
  updateSalespOrTeam(sKey: string, type: string, amount: number, month: number) {
    if (this.selectedNames) {
      let skey = Number(sKey);
      let count = this.mutipleSalespTeams[skey][type][month];
      if (count || count === 0) {
        count = count + Number(amount)
      }
      this.mutipleSalespTeams[skey][type][month] = count;
    }
  }
  resetGraph() {
    this.showGraph = false;
    this.months = {
      baseAmount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
      forecastAmount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
    };
  }

}
